export const roles = [
  { value: "Uberadmin", label: "Uberadmin" },
  { value: "Editor", label: "Editor" },
  { value: "Viewer", label: "Viewer" },
];

export const creatableRoles = [
  { value: "Editor", label: "Editor" },
  { value: "Viewer", label: "Viewer" },
];

export const statusOptions = [
  { value: "DRAFT", label: "DRAFT", key: "DRAFT" },
  { value: "PUBLISHED", label: "PUBLISHED", key: "PUBLISHED" },
];
